import { useEffect, useMemo, useRef, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Menu, Paper } from '@mantine/core';
import axios from '../../axios';
import { useNavigate } from 'react-router-dom';
const Example = ({ updateProductModalSetting, handlePageUpdate, userType }) => {
  const navigate = useNavigate();

  // Modify columns based on userType
  const columns = useMemo(() => [
    {
      accessorKey: 'username',
      header: 'Username',
      size: 250,
    },
    {
      accessorKey: 'full_name',
      header: userType === 'Admin' ? 'Center Manager' : 'Full Name',
      size: 200,
    },
    {
      accessorKey: 'phone_no',
      header: 'Phone No',
      size: 200,
    },
    {
      accessorKey: 'email',
      header: 'Email',
      size: 250,
    },
    {
      accessorKey: 'user_type',
      header: userType === 'Admin' ? 'MIS Manager' : 'User Type',
      size: 150,
    },
  ], [userType]);

  // Optionally access the underlying virtualizer instance
  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);
  useEffect(() => {
    axios.post('/users/getAll',{
      user_type:userType
    })
      .then((res) => {
        // Transform user_type values
        const transformedData = res.data.users.map(user => ({
          ...user,
          user_type: user.user_type === 'Admin'
            ? 'Center Manager'
            : user.user_type === 'Manager'
              ? 'MIS Manager'
              : user.user_type,
        }));
        setData(transformedData);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, [handlePageUpdate]);

  useEffect(() => {
    try {
      // Scroll to the top of the table when the sorting changes
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>
      </>
    ),
  });

  return (
    <Paper shadow="sm" p="lg" withBorder>
      <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '500px', width: '100%' }}>
        <MantineReactTable
          table={table}
          striped // Enables the striped rows
          highlightOnHover
          horizontalSpacing="md"
          verticalSpacing="sm"
          fontSize="sm"
          withColumnBorders
          borderRadius="md"
          withGlobalFilter
          height={400}
          rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
          enablePagination={true} // Enables pagination
        />
      </div>
    </Paper>
  );
};

export default Example;
